import { defineComponent as _defineComponent } from 'vue';
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, normalizeClass as _normalizeClass, createVNode as _createVNode, createElementVNode as _createElementVNode } from "vue";
const _hoisted_1 = ["id", "aria-pressed", "title", "onClick"];
import clsx from 'clsx';
import { tv } from 'tailwind-variants';
import { SpriteIcons } from '@/user/components/common';
export default /*@__PURE__*/ _defineComponent({
    __name: 'CalendarListToggle',
    props: {
        selectedItem: { default: 'calendar' },
        className: { default: undefined }
    },
    emits: ["update:selectedItem", "change"],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const emit = __emit;
        const calendarListToggle = tv({
            variants: {
                part: {
                    container: 'inline-flex overflow-hidden',
                    defaultButton: 'flex size-36 items-center justify-center border-1',
                },
                name: {
                    calendar: 'rounded-l-6 border-r-0',
                    list: 'rounded-r-6 border-l-0',
                },
                isSelected: {
                    true: 'border-blue-700 bg-blue-700 text-white',
                    false: 'border-gray-250 bg-white text-gray-400',
                },
            },
        });
        const buttons = ['calendar', 'list'];
        const handleClick = (name) => {
            emit('update:selectedItem', name);
            emit('change', name);
        };
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", {
                class: _normalizeClass(`inline-flex overflow-hidden ${props.className || ''}`)
            }, [
                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(buttons, (name) => {
                    return _createElementVNode("button", {
                        id: name,
                        key: name,
                        "aria-pressed": props.selectedItem === name,
                        class: _normalizeClass(_unref(clsx)(_unref(calendarListToggle)({
                            part: 'defaultButton',
                            name,
                            isSelected: props.selectedItem === name,
                        }))),
                        title: name,
                        type: "button",
                        onClick: ($event) => (handleClick(name))
                    }, [
                        _createVNode(_unref(SpriteIcons), {
                            "aria-hidden": "true",
                            class: _normalizeClass(`size-20 ${props.selectedItem === name ? 'text-white' : 'text-gray-400'}`),
                            name: name
                        }, null, 8, ["class", "name"])
                    ], 10, _hoisted_1);
                }), 64))
            ], 2));
        };
    }
});
